const routes = [
    {
        path: '/eventtimetable',
        component: () => import('@/pages/eventTimetable/Home.vue'),
        meta: { breadCrumb: 'Event Slots', entity: 'eventSlots' },
        children: [
            {
                name: 'eventtimetable',
                path: '',
                component: () => import('@/pages/eventTimetable/Timetable.vue'),
            },
            {
                name: 'eventtimetablelist',
                path: 'list',
                component: () => import('@/pages/eventTimetable/List.vue'),
            },
            {
                name: 'editEventSlots',
                path: 'edit/:id',
                props: true,
                component: () => import('@/pages/eventTimetable/Editor.vue'),
            },
            {
                name: 'newEventSlot',
                path: 'new',
                props: true,
                component: () => import('@/pages/eventTimetable/Editor.vue'),
            },
        ],
    },
]

export default routes
